import * as React from 'react';
import { TButtonSize } from '@cian/ui-kit/button/types';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import { CianNewbuildingChatButton, CianNewbuildingChatButtonContext } from '@cian/newbuilding-chat-component';
import { useDispatch, useSelector } from 'react-redux';

import { setBuilderChatButtonClicked } from '../../actions/builderChat';
import { useBuilderChat } from '../../hooks/builderChat';
import { getProduct } from '../../selectors/analytics';
import { INewbuilding } from '../../types/newbuilding';
import { isBuilderChatEnabledByNewbuilding } from '../../utils/builderChat';
import { ChatOnboardingContainer } from '../ChatOnboardingContainer';
import { useChatButtonContextValue } from './hooks';

interface IBuilderChatButtonContainerProps {
  newbuilding: INewbuilding;
  buttonSize?: TButtonSize;
  isPromoSnippet?: boolean;
}

export const BuilderChatButtonContainer: React.FC<IBuilderChatButtonContainerProps> = ({
  newbuilding,
  buttonSize = 'XS',
  isPromoSnippet = false,
}) => {
  const product = useSelector(getProduct(newbuilding.id));

  const isChatEnabled = isBuilderChatEnabledByNewbuilding(newbuilding);
  const chatButtonContextValue = useChatButtonContextValue(newbuilding);

  const { openChat } = useBuilderChat({ gaLabel: newbuilding.gaLabels.full, product, isPromoSnippet });

  const dispatch = useDispatch();

  const handleButtonClick = React.useCallback(() => {
    dispatch(setBuilderChatButtonClicked());
  }, [dispatch]);

  if (!isChatEnabled) {
    return null;
  }

  const messageButton = (
    <CianNewbuildingChatButtonContext.Provider value={chatButtonContextValue}>
      <CianNewbuildingChatButton
        size={buttonSize}
        beforeIcon={<IconCommunicationMessage16 color="icon-main-default" />}
        theme="fill_secondary"
        type="button"
        onClick={handleButtonClick}
        onChatOpen={openChat}
      >
        Написать
      </CianNewbuildingChatButton>
    </CianNewbuildingChatButtonContext.Provider>
  );

  if (isPromoSnippet) {
    return (
      <ChatOnboardingContainer type="builder" placement="bottom-start">
        {messageButton}
      </ChatOnboardingContainer>
    );
  }

  return messageButton;
};
